var _scrollIntoView;

_scrollIntoView = function(element) {
  var $element, $parent, elementBottom, elementTop, parentBottom, parentTop;
  $element = $(element);
  $parent = $element.parents('.scroll-area');
  parentTop = $parent.offset().top;
  elementTop = $element.offset().top;
  parentBottom = parentTop + $parent.height();
  elementBottom = elementTop + $element.outerHeight();
  if (elementBottom > parentBottom) {
    $element[0].scrollIntoView(false);
  } else if (elementTop < parentTop) {
    $element[0].scrollIntoView();
  }
};

ko.bindingHandlers.scrollTo = {
  update: function(element, valueAccessor) {
    var value;
    value = ko.unwrap(valueAccessor()) || false;
    if (value) {
      return _scrollIntoView(element);
    }
  }
};
